import { gql } from '@apollo/client' ;

export default gql`
  mutation markExerciseAsComplete($id: ID!) {
    completeExercise: completeEducation(input: {
      id: $id,
    }) {
      carePlanActivity {
        id
        status
      }
    }
  }
`;
